<template>
    <div class="flex">
        <ButtonCircle
                title="Undo: Ctrl+Z"
                :disabled="!canUndo || disabled"
                @click="undo"
        ><i class="icon-arrow-curved icon-revers"></i></ButtonCircle>
        <ButtonCircle
                title="Redo: Ctrl+Shift+Z"
                :disabled="!canRedo || disabled"
                @click="redo"
        ><i class="icon-arrow-curved"></i></ButtonCircle>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "UndoRedo",

        components: {
            ButtonCircle
        },

        props: [
            'disabled',
        ],

        computed: {
            ...mapState('editor', [
                'points',
            ]),

            ...mapGetters('undoRedo', [
                'canUndo',
                'canRedo',
            ]),

            pointsForWatch() {
                // convert to JSON string to detect changes of the children's values
                return JSON.stringify(this.points);
            },

        },

        methods: {
            ...mapActions('undoRedo', [
                'undo',
                'redo',
                'addToHistory',
            ]),

            keyUp(e) {
                const isCtrl = e.ctrlKey;
                const isShift = e.shiftKey;
                const keyCode = e.code;

                if(isCtrl && keyCode === 'KeyZ') {
                    if (isShift) {

                        this.canRedo && this.redo();
                    }
                    else  {
                        this.canUndo && this.undo();
                    }
                }
            },

        },

        watch: {
            pointsForWatch: {
                handler(newValue, oldValue) {
                    const name = 'points';

                    let isTheSameValue = newValue === oldValue;

                    // don't save to the history if nothing was changed
                    if (isTheSameValue) return;

                    this.addToHistory({name, newValue, oldValue});
                },
                deep: true,
            },

        },

        beforeMount() {
            window.addEventListener("keyup", this.keyUp, false)
        },

        beforeUnmount() {
            window.removeEventListener("keyup", this.keyUp);
        }

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>